//CSS
import './Contact.css'

//MUI
import { Box, Container, Typography, useMediaQuery } from '@mui/material'
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import EmailIcon from '@mui/icons-material/Email';

//Components
import Form from '../Form/Form';

import { TARGET_EMAIL } from '../../constants/contants';

const Contact = () => {
    const matches = useMediaQuery('(max-width: 500px)')
    return (
        <>
            <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3732.670983629438!2d-103.38298599999999!3d20.6829605!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8428af0079e00525%3A0xbdf34ca5c7567e53!2sFACTOR%20M%C3%81S%20HEALTH!5e0!3m2!1ses-419!2smx!4v1750361172123!5m2!1ses-419!2smx"
                width="100%" height={matches ? "350" : '500'} title='f+h' style={{ border: '0' }} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade">
            </iframe>
            <Container maxWidth='xl' sx={{ my: 6 }}>
                <Typography variant='h5' sx={{ color: '#011E41', fontWeight: '900', mb: 3 }}>Envíanos un mensaje</Typography>
                <Form type={'contact'} />
                <Box sx={{ mt: 6 }}>
                    <Typography variant='h4' sx={{ color: '#004A86', fontWeight: '900', mb: 3 }} textAlign='center'>Solicite un presupuesto sin costo:</Typography>
                    <Box display='flex' gap='8px' mb={2} justifyContent='center'>
                        <WhatsAppIcon sx={{ my: 'auto', color: '#25D366', fontSize: '28px' }} />
                        <Box sx={{ my: 'auto' }}>
                            <a href='https://api.whatsapp.com/send?phone=523332171890&text=Hola,+quisiera+m%C3%A1s+informaci%C3%B3n+sobre+(escriba+el+tema+sobre+el+que+quiera+saber+m%C3%A1s)'
                                style={{ textDecoration: 'none', color: '#868686', fontSize: '18px' }}>33 3217 1890</a>
                        </Box>
                    </Box>

                    <Box display='flex' gap='8px' mb={8} justifyContent='center'>
                        <EmailIcon sx={{ my: 'auto', color: '#A436D2', fontSize: '28px' }} />
                        <Box sx={{ my: 'auto' }}>
                            <a href={`mailto:${TARGET_EMAIL}`}
                                style={{ textDecoration: 'none', color: '#868686', fontSize: '18px' }}>{TARGET_EMAIL}</a>
                        </Box>
                    </Box>
                    <Typography variant='h4' textAlign='center' sx={{ color: '#868686', fontStyle: 'italic' }}>
                        La salud de su equipo, nuestra prioridad
                    </Typography>
                </Box>
            </Container>
        </>
    )
}

export default Contact